module.exports = __webpack_public_path__ + "static/img/hb_49-min.4305d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_49-min.png
// module id = SFDu
// module chunks = 1